import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export const Percentage = (props) => (
    <SvgIcon {...props}>
        <circle fill="#eda821" cx="16" cy="16" r="13" />
        <path fill="#353535" d="M16 30C8.3 30 2 23.7 2 16S8.3 2 16 2s14 6.3 14 14-6.3 14-14 14zm0-26C9.4 4 4 9.4 4 16s5.4 12 12 12 12-5.4 12-12S22.6 4 16 4zm-5.2 10c0 .7.1 1.3.2 1.7.1.4.3.5.6.5.6 0 .8-.7.8-2.2 0-1.5-.3-2.2-.8-2.2-.3 0-.5.2-.6.5-.2.4-.2 1-.2 1.7zm3.9 0c0 1.3-.3 2.4-.8 3-.5.7-1.3 1-2.3 1-1 0-1.7-.3-2.2-1-.5-.7-.8-1.7-.8-3 0-2.7 1-4 3-4 1 0 1.7.3 2.3 1 .5.7.8 1.7.8 3zm6-3.8L13.6 23h-2.1l7.1-12.8h2.1zm-.9 8.9c0 .7.1 1.3.2 1.7.1.4.3.5.6.5.6 0 .8-.7.8-2.2 0-1.5-.3-2.2-.8-2.2-.3 0-.5.2-.6.5-.2.4-.2 1-.2 1.7zm3.9 0c0 1.3-.3 2.4-.8 3-.5.7-1.3 1-2.3 1-1 0-1.7-.3-2.2-1-.5-.7-.8-1.7-.8-3 0-2.7 1-4 3-4 1 0 1.7.3 2.3 1 .5.7.8 1.7.8 3z" />
    </SvgIcon>
);

Percentage.defaultProps = {
    viewBox: '0 0 32 32'
};

export default Percentage;
